
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"88","height":"65"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#444242","d":"M88 13.172v41.569C88 60.405 84.206 65 79.52 65H8.48C3.794 65 0 60.373 0 54.74V10.269C0 4.594 3.794 0 8.48 0h71.04C84.206 0 88 4.595 88 10.267v2.905zM6.917 6.653c0-.083 0-.296-.02-.32a.305.305 0 00-.154-.195.277.277 0 00-.168.118.407.407 0 00-.053.148l-1.253 4.3a7.301 7.301 0 00-.29 1.873 7.404 7.404 0 00.322 2.369.245.245 0 01.004.168.21.21 0 01-.104.122.365.365 0 01-.216.06c-.242-.036-.48-.095-.721-.131a.275.275 0 00-.237.065.217.217 0 00-.02.156.192.192 0 00.088.123l.142.118c.837.687 1.67 1.386 2.512 2.061.489.412.998.792 1.526 1.138a5.114 5.114 0 002.738.734c.263 0 .337.118.263.385a3.894 3.894 0 01-.215.539c-.037.083-.116.136-.143.22a1.323 1.323 0 00-.036.29c.084.008.168.008.252 0a.445.445 0 00.148-.107c.984-.782 1.958-1.594 2.959-2.37 1.184-.877 2.069-2.18 2.511-3.696.005-.08.05-.15.115-.18a.173.173 0 01.196.032c.127.079.244.176.347.29.1.107.163.255.263.362a.26.26 0 00.237.083.361.361 0 00.09-.255.843.843 0 00-.058-.26c-.369-1.28-.753-2.553-1.09-3.845-.376-1.507-1.196-2.825-2.327-3.737a.302.302 0 01-.143-.264c0-.111.055-.213.143-.263.183-.133.375-.25.574-.35a.685.685 0 00.163-.077.307.307 0 00.095-.19.203.203 0 00-.132-.124 1.003 1.003 0 00-.29-.035H11.22a5.292 5.292 0 00-2.722.592c-.39.23-.77.483-1.138.758-.158.107-.252.089-.316-.112a3.483 3.483 0 01-.126-.593zM27 31v4h4v-4h-4zm15-11v7h4v-7h-4zm-4 11v3.5h3.5V38H45v-7h-7zm11.2 0v3.6h3.6v3.6h-3.6v3.6H42V49h3.6v-3.6h7.2V49h3.6v-3.6H60v-7.2h-3.6v-3.6H60V31h-3.6v3.6h-3.6V31h-3.6zM57 45v-7h-4v7h4zm-8-29v11h11V16H49zm4 4h4v4h-4v-4zm-26-4v11h11V16H27zm4 4h4v4h-4v-4zm-4 18v11h11V38H27zm4 4h4v4h-4v-4z"}})])
          )
        }
      }
    